<template>
  <div>
    <div v-if="showComing" class="show-coming">
      <div class="coming-soon-text">Scorecard section is coming soon....</div>
      <img src="../../../../../assets/svg/chart2.svg" alt="" class="svg1" />
    </div>

    <div class="viz-shell" v-if="title === 'Demographics'">
      <iframe class="viz-frame" :src="url" title="Scorecard visualization" />
    </div>
    <div class="viz-shell" v-if="title === 'Health_Outcomes_and_Service_Coverage'">
      <iframe class="viz-frame" :src="url2" title="Scorecard visualization" />
    </div>
    <div class="viz-shell" v-if="title === 'Health_Facility'">
      <iframe class="viz-frame" :src="url3" title="Scorecard visualization" />
    </div>
    <div class="viz-shell" v-if="title === 'Health_Workforce'">
      <iframe class="viz-frame" :src="url4" title="Scorecard visualization" />
    </div>
    <div class="viz-shell" v-if="title === 'Health_Service_Access'">
      <iframe class="viz-frame" :src="url5" title="Scorecard visualization" />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ScorecardSection',
  data() {
    return {
      title: '',
      url: 'https://public.tableau.com/views/MSDATDemographicDashboardScorecard/Dashboard?:language=en-US&publish=yes&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link&publish=yes&:display_count=n&:showVizHome=no&:embed=true',
      url2: 'https://public.tableau.com/views/UPDATEDHEALTHOUTCOMESSCORECARD/SCORECARD?:language=en-US&publish=yes&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link&publish=yes&:display_count=n&:showVizHome=no&:embed=true',
      url3: 'https://public.tableau.com/views/HF_scorecard/Dashboard1?:language=en-US&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link&publish=yes&:display_count=n&:showVizHome=no&:embed=true',
      url4: 'https://public.tableau.com/views/HealthWorkforceScorecard/UpdatedHealthWorkforceScorecard?:language=en-US&publish=yes&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link&publish=yes&:display_count=n&:showVizHome=no&:embed=true',
      url5: 'https://public.tableau.com/views/HealthServiceAccessScorecard/Dashboard?:language=en-US&publish=yes&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link&publish=yes&:display_count=n&:showVizHome=no&:embed=true',
      showComing: true,
    };
  },
  methods: {
    ...mapMutations('MSDAT_STORE', ['ADD_CONTROL_PANEL', 'CLEAR_CONTROL_PANEL']),
  },
  created() {
    this.title = this.$route.params.name;
    if (
      this.title === 'Demographics'
      || this.title === 'Health_Outcomes_and_Service_Coverage'
      || this.title === 'Health_Facility'
      || this.title === 'Health_Workforce'
      || this.title === 'Health_Service_Access'
    ) {
      this.showComing = false;
    }
  },
};
</script>

<style scoped>
.viz-shell {
  padding: 1rem;
}

.viz-frame {
  display: block;
  width: 100%;
  height: min(78vh, 900px);
  min-height: 620px;
  border: 0;
}

.show-coming {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.svg1 {
  width: 400px;
}
.coming-soon-text {
  font-size: 15px;
  font-weight: 500;
  margin: 30px;
}

@media (max-width: 768px) {
  .viz-shell {
    padding: 0.5rem;
  }

  .viz-frame {
    height: calc(100vh - 10rem);
    min-height: 34rem;
  }
}
</style>
